import { modules } from '@veritone/glc-redux';
const {
  config: { getConfig },
} = modules;

const getGraphQLEndpoint = (state: any) => {
  const config = getConfig<Window['config']>(state);
  return config.graphQLEndpoint;
};

export default getGraphQLEndpoint;
